import * as z from 'zod'
import { DriverRegistrationRequest } from '~/shared/api'

export const baseSchema = DriverRegistrationRequest.schema
  .pick({
    // Паспорт
    passportNumber: true,
    passportIssueDate: true,
    registrationAddress: true,
    divisionCode: true,
    passportIssued: true,
    birthDate: true,
    birthPlace: true,
    // ВУ
    firstName: true,
    middleName: true,
    lastName: true,
    drivingLicenseNumber: true,
    drivingLicenseIssueDate: true,
    drivingLicenseExpirationDate: true,
    drivingExperienceStartDate: true,
  })
  .partial()

export type FormValues = z.infer<typeof baseSchema>
